import { render } from "./Captcha.vue?vue&type=template&id=c4adc82c&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=c4adc82c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4adc82c"],['__file',"src/views/Login/Captcha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4adc82c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4adc82c', __exports__)) {
    api.reload('c4adc82c', __exports__)
  }
  
  module.hot.accept("./Captcha.vue?vue&type=template&id=c4adc82c&scoped=true", () => {
    api.rerender('c4adc82c', render)
  })

}


export default __exports__